import { parse } from "date-fns";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function SchedulingsValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    workTimesId: Yup.string().optional(),
    patientsId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    employeesId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    proceduresId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    date: Yup.string()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }
        const result = parse(originalValue, "dd/MM/yyyy", new Date());
        return result;
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.select a date")),
    value: Yup.string().required(t("LABEL.required")),
    return: Yup.boolean().optional(),
    confirmWhatsApp: Yup.boolean().optional(),
    comments: Yup.string()
      .max(100, t("LABEL.maximum 100 characters"))
      .optional(),
    hour: Yup.array()
      .of(Yup.string().required(t("LABEL.select a time")))
      .min(1, t("LABEL.select at least one hour"))
      .required(t("LABEL.select a time")),
    payment_method: Yup.string().optional(),
    mode: Yup.string().optional(),
    entry: Yup.string().optional(),
    type_periodic: Yup.string().optional(),
    total_installments: Yup.string().optional(),
    period: Yup.string().required(t("LABEL.select a period")),
    queue: Yup.string().optional(),
    sms: Yup.boolean().optional(),
    whatsapp: Yup.boolean().optional(),
  });

  return validation;
}

export function UpdateSchedulingsValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    workTimesId: Yup.string().optional(),
    patientsId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    employeesId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    proceduresId: Yup.string().required(
      t("PLACEHOLDER.select one of the options")
    ),
    date: Yup.string().required(t("LABEL.select a date")),
    value: Yup.string().required(t("LABEL.required")),
    return: Yup.boolean().optional(),
    confirmWhatsApp: Yup.boolean().optional(),
    comments: Yup.string()
      .max(100, t("LABEL.maximum 100 characters"))
      .optional(),
    hour: Yup.string().required(t("LABEL.select a time")),
    payment_method: Yup.string().optional(),
    mode: Yup.string().optional(),
    entry: Yup.string().optional(),
    type_periodic: Yup.string().optional(),
    total_installments: Yup.string().optional(),
  });

  return validation;
}
